// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* fallow-ignore-file */
.PX5h2Lnba2K9_dRB1sdf {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: var(--campaign-tab-width);
  max-width: 100%;
  margin: 0 8px;
  filter: drop-shadow(0 0 37.5px rgba(60, 255, 0, 0.6));
}
.Yxi8MWPNHhNWMSHHD3Rg {
  position: relative;
  flex: 1 1 0;
}
.Yxi8MWPNHhNWMSHHD3Rg [data-variant],
.Yxi8MWPNHhNWMSHHD3Rg [data-percent] {
  border-width: var(--progress-item-border) 0 var(--progress-item-border) 0;
}
.Yxi8MWPNHhNWMSHHD3Rg:first-child [data-variant],
.Yxi8MWPNHhNWMSHHD3Rg:first-child [data-percent] {
  border-radius: 7.5px 0 0 7.5px;
  border-width: var(--progress-item-border) 0 var(--progress-item-border) var(--progress-item-border);
}
.Yxi8MWPNHhNWMSHHD3Rg:last-child [data-variant],
.Yxi8MWPNHhNWMSHHD3Rg:last-child [data-percent] {
  border-width: var(--progress-item-border) var(--progress-item-border) var(--progress-item-border) 0;
}
.Yxi8MWPNHhNWMSHHD3Rg:last-child [data-variant] {
  border-radius: 0 7.5px 7.5px 0;
}
.Yxi8MWPNHhNWMSHHD3Rg:last-child [data-percent] {
  border-radius: 0;
}
.Yxi8MWPNHhNWMSHHD3Rg:last-child [data-percent='100'] {
  border-radius: 0 7.5px 7.5px 0;
}
.uTfioDis4qIr1Cv_rrYr {
  position: relative;
  flex: 0 0 auto;
  width: 90px;
  height: 33px;
  /* Tuck the neighbouring bar segments slightly UNDER the pill (it's opaque at
     the track's height) so no gap shows between a segment and the pill.
     z-index keeps the pill above the segment that FOLLOWS it in the DOM too. */
  margin: 0 -3px;
  z-index: 1;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .uTfioDis4qIr1Cv_rrYr {
    height: 22px;
    width: 60px;
  }
}
.VIr0nC2hjUlBcKDNk_04 {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  /* object-fit: contain; */
}
.Z9Dmpm5Y5pFZtld5o5e9 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 36px;
  display: flex;
  align-items: center;
  font-family: var(--font-family-secondary, inherit);
  font-size: 21px;
  font-weight: 700;
  letter-spacing: 1.2px;
  white-space: nowrap;
}
.Z9Dmpm5Y5pFZtld5o5e9[data-pill-status='unlocked'] {
  color: #fff;
}
.Z9Dmpm5Y5pFZtld5o5e9[data-pill-status='locked'] {
  color: #d3d3d3;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .Z9Dmpm5Y5pFZtld5o5e9 {
    font-size: 14px;
    letter-spacing: 0.8px;
    left: 24px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  /* Shorter segments flanking pill 2 (level 2). */
  [data-has-many='false'] [data-levels='3'] .Yxi8MWPNHhNWMSHHD3Rg:nth-child(3),
  [data-has-many='false'] [data-levels='3'] .Yxi8MWPNHhNWMSHHD3Rg:nth-child(5) {
    flex: 2.5 1 0;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  /* Shorter segments flanking pill 2 (level 2). */
  [data-has-many='false'] [data-levels='3'] .Yxi8MWPNHhNWMSHHD3Rg:nth-child(3),
  [data-has-many='false'] [data-levels='3'] .Yxi8MWPNHhNWMSHHD3Rg:nth-child(5) {
    flex: 2.5 1 0;
  }
}
}
}
}
/* More than one campaign */
[data-has-many='true'] .PX5h2Lnba2K9_dRB1sdf {
  margin: 0 18px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-has-many='true'] .PX5h2Lnba2K9_dRB1sdf {
    margin: 0 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/RebateCard/components/RebateProgressBar/RebateProgressBar.module.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,qDAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,yEAAyE;AAC3E;AACA;;EAEE,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;;EAEE,mGAAmG;AACrG;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ;;+EAE6E;EAC7E,cAAc;EACd,UAAU;AACZ;AACA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;IACf,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;AAAA;EACE,gDAAgD;EAChD;;IAEE,aAAa;EACf;AACF;AAAA;AANA;AAAA;AAAA;AAAA;EACE,gDAAgD;EAChD;;IAEE,aAAa;EACf;AACF;AAAA;AAAA;AAAA;AACA,2BAA2B;AAC3B;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["/* fallow-ignore-file */\n.rebateProgressBar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: var(--campaign-tab-width);\n  max-width: 100%;\n  margin: 0 8px;\n  filter: drop-shadow(0 0 37.5px rgba(60, 255, 0, 0.6));\n}\n.segment {\n  position: relative;\n  flex: 1 1 0;\n}\n.segment [data-variant],\n.segment [data-percent] {\n  border-width: var(--progress-item-border) 0 var(--progress-item-border) 0;\n}\n.segment:first-child [data-variant],\n.segment:first-child [data-percent] {\n  border-radius: 7.5px 0 0 7.5px;\n  border-width: var(--progress-item-border) 0 var(--progress-item-border) var(--progress-item-border);\n}\n.segment:last-child [data-variant],\n.segment:last-child [data-percent] {\n  border-width: var(--progress-item-border) var(--progress-item-border) var(--progress-item-border) 0;\n}\n.segment:last-child [data-variant] {\n  border-radius: 0 7.5px 7.5px 0;\n}\n.segment:last-child [data-percent] {\n  border-radius: 0;\n}\n.segment:last-child [data-percent='100'] {\n  border-radius: 0 7.5px 7.5px 0;\n}\n.pill {\n  position: relative;\n  flex: 0 0 auto;\n  width: 90px;\n  height: 33px;\n  /* Tuck the neighbouring bar segments slightly UNDER the pill (it's opaque at\n     the track's height) so no gap shows between a segment and the pill.\n     z-index keeps the pill above the segment that FOLLOWS it in the DOM too. */\n  margin: 0 -3px;\n  z-index: 1;\n}\n@media (--campaign-mobile) {\n  .pill {\n    height: 22px;\n    width: 60px;\n  }\n}\n.pillIcon {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  /* object-fit: contain; */\n}\n.pillPercent {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 36px;\n  display: flex;\n  align-items: center;\n  font-family: var(--font-family-secondary, inherit);\n  font-size: 21px;\n  font-weight: 700;\n  letter-spacing: 1.2px;\n  white-space: nowrap;\n}\n.pillPercent[data-pill-status='unlocked'] {\n  color: #fff;\n}\n.pillPercent[data-pill-status='locked'] {\n  color: #d3d3d3;\n}\n@media (--campaign-mobile) {\n  .pillPercent {\n    font-size: 14px;\n    letter-spacing: 0.8px;\n    left: 24px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  /* Shorter segments flanking pill 2 (level 2). */\n  [data-has-many='false'] [data-levels='3'] .segment:nth-child(3),\n  [data-has-many='false'] [data-levels='3'] .segment:nth-child(5) {\n    flex: 2.5 1 0;\n  }\n}\n/* More than one campaign */\n[data-has-many='true'] .rebateProgressBar {\n  margin: 0 18px;\n}\n@media (--campaign-mobile) {\n  [data-has-many='true'] .rebateProgressBar {\n    margin: 0 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rebateProgressBar": `PX5h2Lnba2K9_dRB1sdf`,
	"segment": `Yxi8MWPNHhNWMSHHD3Rg`,
	"pill": `uTfioDis4qIr1Cv_rrYr`,
	"pillIcon": `VIr0nC2hjUlBcKDNk_04`,
	"pillPercent": `Z9Dmpm5Y5pFZtld5o5e9`
};
export default ___CSS_LOADER_EXPORT___;
